import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const HotelIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "HotelIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M19.8729 5.88245V10.3137L19.4854 10.0841C19.3778 10.0195 19.2558 9.98723 19.1338 9.99082C17.8564 9.46695 15.0793 8.49099 11.9863 8.49099C8.89339 8.49099 6.1162 9.46695 4.83884 9.99082C4.72402 9.99082 4.6092 10.0231 4.50873 10.0841L4.20016 10.2707C4.13917 10.2994 4.10687 10.3137 4.0997 10.3173V5.88604C4.0997 4.90649 4.89267 4.11353 5.87221 4.11353H18.0968C19.0764 4.11353 19.8729 4.90649 19.8729 5.88604"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.656 11.3787L19.8729 10.3137L19.4854 10.0841C19.3778 10.0195 19.2558 9.98723 19.1338 9.99082C19.5931 10.181 19.8548 10.3095 19.8728 10.3167V10.3238C19.8333 10.3418 18.3873 11.063 16.2703 11.5976C15.0217 11.9134 13.5434 12.1609 11.9861 12.1609C10.4289 12.1609 8.95062 11.9134 7.70197 11.5976C5.62446 11.0737 4.19282 10.3669 4.10311 10.3274H4.09952L2.34136 11.3823C2.12966 11.5115 2.00049 11.7375 2.00049 11.9851V19.1828C2.00049 19.5703 2.31624 19.8861 2.70375 19.8861H21.2972C21.6847 19.8861 22.0005 19.5703 22.0005 19.1828V11.9851C22.0005 11.7375 21.8713 11.5079 21.6596 11.3823"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default HotelIcon;
